/**
 * Cookies - Politique de gestion des cookies
 * Contenu placeholder à valider par un juriste
 */
import LegalPageLayout from '../components/legal/LegalPageLayout'

export default function Cookies() {
  return (
    <LegalPageLayout
      title="Politique de cookies"
      lastUpdate="[DATE À DÉFINIR]"
    >
      {/* Section 1 - Qu'est-ce qu'un cookie */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          1. Qu'est-ce qu'un cookie ?
        </h2>
        <p className="text-gray-600 mb-4">
          [TEXTE À VALIDER PAR HUMAIN/JURISTE]
        </p>
        <p className="text-gray-600">
          Un cookie est un petit fichier texte déposé sur votre terminal
          (ordinateur, tablette, smartphone) lors de la visite d'un site web.
          Il permet au site de mémoriser des informations sur votre visite.
        </p>
      </section>

      {/* Section 2 - Cookies utilisés */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          2. Les cookies que nous utilisons
        </h2>
        <p className="text-gray-600 mb-4">
          [TEXTE À VALIDER PAR HUMAIN/JURISTE]
        </p>

        {/* Cookies essentiels */}
        <h3 className="text-lg font-medium text-gray-800 mt-6 mb-3">
          2.1 Cookies strictement nécessaires
        </h3>
        <p className="text-gray-600 mb-2">
          Ces cookies sont indispensables au fonctionnement du site. Ils ne
          peuvent pas être désactivés.
        </p>
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm text-gray-600 mt-2">
            <thead>
              <tr className="border-b border-gray-200">
                <th className="text-left py-2 font-medium">Cookie</th>
                <th className="text-left py-2 font-medium">Finalité</th>
                <th className="text-left py-2 font-medium">Durée</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-gray-100">
                <td className="py-2">session_id</td>
                <td className="py-2">Authentification utilisateur</td>
                <td className="py-2">Session</td>
              </tr>
              <tr className="border-b border-gray-100">
                <td className="py-2">cookie-consent</td>
                <td className="py-2">Mémorisation du choix cookies</td>
                <td className="py-2">12 mois</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Cookies analytics */}
        <h3 className="text-lg font-medium text-gray-800 mt-6 mb-3">
          2.2 Cookies de mesure d'audience
        </h3>
        <p className="text-gray-600 mb-2">
          Ces cookies nous permettent de mesurer l'audience du site et
          d'améliorer nos services. Ils sont soumis à votre consentement.
        </p>
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm text-gray-600 mt-2">
            <thead>
              <tr className="border-b border-gray-200">
                <th className="text-left py-2 font-medium">Cookie</th>
                <th className="text-left py-2 font-medium">Finalité</th>
                <th className="text-left py-2 font-medium">Durée</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-gray-100">
                <td className="py-2">[À COMPLÉTER]</td>
                <td className="py-2">Mesure d'audience</td>
                <td className="py-2">[À COMPLÉTER]</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* Section 3 - Gestion des cookies */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          3. Gérer vos préférences
        </h2>
        <p className="text-gray-600 mb-4">
          [TEXTE À VALIDER PAR HUMAIN/JURISTE]
        </p>
        <p className="text-gray-600 mb-4">
          Vous pouvez à tout moment modifier vos préférences en matière de
          cookies :
        </p>

        {/* Bouton pour ouvrir les préférences - placeholder */}
        <div className="bg-gray-100 border border-gray-200 rounded-lg p-4 text-center">
          <p className="text-sm text-gray-500 mb-3">
            [Interface de gestion des cookies à implémenter - Sprint C1]
          </p>
          <button
            type="button"
            className="px-4 py-2 bg-gray-300 text-gray-600 rounded-lg cursor-not-allowed"
            disabled
          >
            Gérer mes préférences cookies
          </button>
        </div>
      </section>

      {/* Section 4 - Gestion via navigateur */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          4. Paramétrage du navigateur
        </h2>
        <p className="text-gray-600 mb-4">
          [TEXTE À VALIDER PAR HUMAIN/JURISTE]
        </p>
        <p className="text-gray-600">
          Vous pouvez également configurer votre navigateur pour accepter ou
          refuser les cookies. Voici les liens vers les procédures des
          principaux navigateurs :
        </p>
        <ul className="list-disc list-inside space-y-1 text-gray-600 mt-2">
          <li>
            <a
              href="https://support.google.com/chrome/answer/95647"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              Google Chrome
            </a>
          </li>
          <li>
            <a
              href="https://support.mozilla.org/fr/kb/activer-desactiver-cookies"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              Mozilla Firefox
            </a>
          </li>
          <li>
            <a
              href="https://support.apple.com/fr-fr/guide/safari/sfri11471/mac"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              Safari
            </a>
          </li>
          <li>
            <a
              href="https://support.microsoft.com/fr-fr/microsoft-edge/supprimer-les-cookies-dans-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              Microsoft Edge
            </a>
          </li>
        </ul>
      </section>

      {/* Section 5 - Plus d'informations */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          5. Plus d'informations
        </h2>
        <p className="text-gray-600 mb-4">
          [TEXTE À VALIDER PAR HUMAIN/JURISTE]
        </p>
        <p className="text-gray-600">
          Pour toute question relative à notre utilisation des cookies, vous
          pouvez nous contacter à : [À COMPLÉTER]
        </p>
        <p className="text-gray-600 mt-4">
          Pour en savoir plus sur les cookies et leur gestion, vous pouvez
          consulter le site de la CNIL :{' '}
          <a
            href="https://www.cnil.fr/fr/cookies-et-autres-traceurs"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            www.cnil.fr/fr/cookies-et-autres-traceurs
          </a>
        </p>
      </section>
    </LegalPageLayout>
  )
}
